import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const ComentarioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='COMENTARIO' htmlFor='text-comentario' md={12} />
      <Col md={12}>
        <Field name='comentario'>
          {({ field }) => <Form.TextArea {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='text-comentario' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ComentarioFormGroup)
